<script setup lang="ts">
import { useWordProcessorStore } from "../useWordProcessorStore";

const editorRef = inject("quillEditor") as any;
const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { selectionRange } = storeToRefs(wordProcessorStore);

const {
  isRecording,
  isStopping,
  isDisabled,
  tooltip,
  toggleDictation,
  abortDictation,
} = useWordProcessorDictation({
  editorRef,
  selectionRange,
});

onUnmounted(() => {
  abortDictation();
});
</script>

<template>
  <BaseIconButton
    :tooltip="tooltip"
    :active="isRecording"
    :disabled="isDisabled || isStopping"
    :show-spinner="isStopping"
    :color="isRecording ? 'danger' : ''"
    @click="toggleDictation"
    :class="[
      'transition-all duration-300 ease-in-out',
      isRecording && !isStopping ? 'recording-active' : ''
    ]"
  >
    <!-- Icon with transition -->
    <transition name="fade" mode="out-in">
      <icon
        v-if="!isStopping"
        name="lucide:mic"
        size="18"
        :class="{
          'text-danger-default animate-pulse': isRecording,
        }"
      />
    </transition>
  </BaseIconButton>
</template>

<style scoped>
@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(161, 0, 0, 0.3);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(161, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(161, 0, 0, 0);
  }
}

@keyframes bg-pulse {
  0%, 100% {
    background-color: rgba(161, 0, 0, 0.1);
  }
  50% {
    background-color: rgba(161, 0, 0, 0.25);
  }
}

.recording-active {
  animation: pulse-glow 2s infinite, bg-pulse 2s infinite ease-in-out !important;
  border: 1px solid rgba(161, 0, 0, 0.2) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.85);
}
</style>
